import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	failToLoadTitleNonFianl: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	refreshButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorImageAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failToLoadTitleNonFianlIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorImageAltIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	failToLoadTitleNonFianl: {
		id: 'software-releases-version-detail-issue-list.error-view.fail-to-load-title-non-fianl',
		defaultMessage: "Can't load issues",
		description: 'Title that is shown when loading issue list is failed',
	},
	refreshButtonLabel: {
		id: 'software-releases-version-detail-issue-list.error-view.refresh-button-label',
		defaultMessage: 'Refresh page',
		description:
			'Description that is shown when loading issue list is failed to let users refresh the page to retry',
	},
	errorImageAlt: {
		id: 'software-releases-version-detail-issue-list.error-view.error-image-alt',
		defaultMessage: 'Image that shows loading issues failed.',
		description: 'Alt text of the error image.',
	},
	failToLoadTitleNonFianlIssueTerminologyRefreshM4: {
		id: 'software-releases-version-detail-issue-list.error-view.fail-to-load-title-non-fianl-issue-terminology-refresh-m4',
		defaultMessage: "Can't load work items",
		description: 'Title that is shown when loading issue list is failed',
	},
	errorImageAltIssueTerminologyRefreshM4: {
		id: 'software-releases-version-detail-issue-list.error-view.error-image-alt-issue-terminology-refresh-m4',
		defaultMessage: 'Image that shows loading work items failed.',
		description: 'Alt text of the error image.',
	},
});
export default messages;
